import styled from 'styled-components';

import { theme } from './GlobalStyles';

const StyledExpander = styled.div`
  ${(props) => !props.isLast && 'border-bottom: 0.0625rem solid #ddd'};
  .summary {
    font-size: 1.5rem;
    cursor: pointer;
    padding: 2rem 1rem;
    position: relative;
    color: ${theme.colors.black};
    margin: 0;
  }
  .summary::after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0.3125rem 0.3125rem 0;
    border-color: ${theme.colors.purple} transparent transparent;
    right: 2rem;
    top: 50%;
    margin-top: -2px;
  }

  &.is-active .summary::after {
    transform: rotateZ(180deg);
  }
  .details {
    display: none;
    margin-bottom: 2rem;
    padding: 0 1rem;
  }
  &.is-active .details {
    display: block;
  }

  ${theme.mediaQueries.above.small} {
    .summary {
      cursor: default;
    }
    .summary::after {
      display: none;
    }
    .details {
      display: block;
    }
  }
`;

function toggle(e) {
  e.target.parentElement.classList.toggle('is-active');
}

const Expander = ({ summary, details, active, isLast }) => {
  return (
    <StyledExpander isLast={isLast} className={`expander ${active ? 'is-active' : ''}`}>
      <h3 onClick={toggle} className="summary">
        {summary}
      </h3>
      <div className="details">{details}</div>
    </StyledExpander>
  );
};

export default Expander;
